document.addEventListener('DOMContentLoaded',function(){
  const toggle=document.querySelector('[data-menu-toggle]');const menu=document.querySelector('[data-main-menu]');
  if(toggle&&menu)toggle.addEventListener('click',function(){const open=menu.classList.toggle('is-open');toggle.setAttribute('aria-expanded',String(open));});
  document.querySelectorAll('[data-product-variant-select]').forEach(function(sel){sel.addEventListener('change',function(){const option=sel.options[sel.selectedIndex];const root=sel.closest('[data-product-root]');const price=root&&root.querySelector('[data-product-price]');const atc=root&&root.querySelector('[data-add-to-cart]');if(price)price.textContent=option.dataset.price||'';const compare=root&&root.querySelector('[data-product-compare-price]');if(compare){const comparePrice=option.dataset.comparePrice||'';compare.textContent=comparePrice;compare.hidden=!comparePrice;}if(atc){atc.disabled=option.dataset.available!=='true';atc.textContent=option.dataset.available==='true'?'Add to cart':'Sold out';}});});
});

(function(){
  'use strict';
  function initReviewSliders(scope){
    var carousels=[];
    if(scope.matches && scope.matches('[data-nova-carousel]')) carousels.push(scope);
    if(scope.querySelectorAll) carousels=carousels.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-nova-carousel]')));
    carousels.forEach(function(root){
      if(root.dataset.novaCarouselReady==='yes') return;
      var track=root.querySelector('[data-carousel-track]');
      if(!track) return;
      var cards=Array.prototype.slice.call(track.querySelectorAll('[data-carousel-card]'));
      if(!cards.length) return;
      root.dataset.novaCarouselReady='yes';
      var prev=root.querySelector('[data-carousel-prev]');
      var next=root.querySelector('[data-carousel-next]');
      var counter=root.querySelector('[data-carousel-counter]');
      var progress=root.querySelector('[data-carousel-progress]');
      var pending=false;
      function closestIndex(){
        var left=track.getBoundingClientRect().left;
        var index=0,min=Infinity;
        cards.forEach(function(card,i){
          var distance=Math.abs(card.getBoundingClientRect().left-left);
          if(distance<min){min=distance;index=i;}
        });
        return index;
      }
      function update(){
        pending=false;
        var index=closestIndex();
        var max=track.scrollWidth-track.clientWidth;
        if(prev)prev.disabled=track.scrollLeft<=3;
        if(next)next.disabled=track.scrollLeft>=max-3;
        if(counter)counter.textContent=(index+1)+' / '+cards.length;
        if(progress)progress.style.width=((index+1)/cards.length*100)+'%';
      }
      function requestUpdate(){
        if(!pending){pending=true;window.requestAnimationFrame(update);}
      }
      function move(delta){
        var index=closestIndex();
        var target=cards[Math.min(Math.max(0,index+delta),cards.length-1)];
        if(!target)return;
        var position=track.scrollLeft+(target.getBoundingClientRect().left-track.getBoundingClientRect().left);
        var reduced=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollTo({left:position,behavior:reduced?'auto':'smooth'});
      }
      if(prev)prev.addEventListener('click',function(){move(-1);});
      if(next)next.addEventListener('click',function(){move(1);});
      track.addEventListener('scroll',requestUpdate,{passive:true});
      track.addEventListener('keydown',function(event){
        if(event.key==='ArrowRight'){event.preventDefault();move(1);}
        if(event.key==='ArrowLeft'){event.preventDefault();move(-1);}
      });
      window.addEventListener('resize',requestUpdate,{passive:true});
      root.addEventListener('shopify:block:select',function(event){
        var card=event.target && event.target.closest && event.target.closest('[data-carousel-card]');
        if(card){card.scrollIntoView({block:'nearest',inline:'center'});requestUpdate();}
      });
      update();
    });
  }
  function onReady(){initReviewSliders(document);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',onReady);
  else onReady();
  document.addEventListener('shopify:section:load',function(event){initReviewSliders(event.target);});
})();


/* Zentech Nova V5: independent gallery carousel (keeps V4 review carousels untouched) */
(function(){
  'use strict';
  function initProductGalleries(scope){
    var galleries=[];
    if(scope.matches && scope.matches('[data-product-gallery]')) galleries.push(scope);
    if(scope.querySelectorAll) galleries=galleries.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-product-gallery]')));
    galleries.forEach(function(root){
      if(root.dataset.novaGalleryReady==='yes')return;
      var track=root.querySelector('[data-gallery-track]');
      if(!track)return;
      var slides=Array.prototype.slice.call(track.querySelectorAll('[data-gallery-slide]'));
      var thumbs=Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
      if(!slides.length)return;
      root.dataset.novaGalleryReady='yes';
      var prev=root.querySelector('[data-gallery-prev]');
      var next=root.querySelector('[data-gallery-next]');
      var current=root.querySelector('[data-gallery-current]');
      var thumbrow=root.querySelector('[data-gallery-thumbs]');
      var updating=false;
      var reduced=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function visibleIndex(){
        var edge=track.getBoundingClientRect().left;
        var closest=0, min=Infinity;
        slides.forEach(function(slide,i){
          var distance=Math.abs(slide.getBoundingClientRect().left-edge);
          if(distance<min){closest=i;min=distance;}
        });
        return closest;
      }
      function refresh(){
        updating=false;
        var index=visibleIndex();
        if(prev)prev.disabled=index===0;
        if(next)next.disabled=index>=slides.length-1;
        if(current)current.textContent=String(index+1);
        thumbs.forEach(function(thumb,i){
          var active=i===index;
          thumb.classList.toggle('is-active',active);
          thumb.setAttribute('aria-current',active?'true':'false');
        });
        var activeThumb=thumbs[index];
        if(activeThumb && thumbrow){
          var left=activeThumb.offsetLeft-thumbrow.offsetLeft;
          if(left < thumbrow.scrollLeft){thumbrow.scrollLeft=left;}
          else if(left+activeThumb.offsetWidth > thumbrow.scrollLeft+thumbrow.clientWidth){
            thumbrow.scrollLeft=left+activeThumb.offsetWidth-thumbrow.clientWidth;
          }
        }
      }
      function requestRefresh(){
        if(!updating){updating=true;window.requestAnimationFrame(refresh);}
      }
      function show(index,animate){
        var slide=slides[Math.max(0,Math.min(index,slides.length-1))];
        if(!slide)return;
        var left=track.scrollLeft+slide.getBoundingClientRect().left-track.getBoundingClientRect().left;
        track.scrollTo({left:left,behavior:animate&&!reduced?'smooth':'auto'});
        requestRefresh();
      }
      if(prev)prev.addEventListener('click',function(){show(visibleIndex()-1,true);});
      if(next)next.addEventListener('click',function(){show(visibleIndex()+1,true);});
      thumbs.forEach(function(thumb,i){thumb.addEventListener('click',function(){show(i,true);});});
      track.addEventListener('scroll',requestRefresh,{passive:true});
      track.addEventListener('keydown',function(event){
        if(event.key==='ArrowRight'){event.preventDefault();show(visibleIndex()+1,true);}
        if(event.key==='ArrowLeft'){event.preventDefault();show(visibleIndex()-1,true);}
      });
      window.addEventListener('resize',requestRefresh,{passive:true});
      var selected=root.dataset.selectedMediaId;
      var initial=selected?slides.findIndex(function(slide){return slide.dataset.mediaId===selected;}):-1;
      if(initial>0){show(initial,false);}else{refresh();}
    });
  }
  function onReady(){initProductGalleries(document);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',onReady);
  else onReady();
  document.addEventListener('shopify:section:load',function(event){initProductGalleries(event.target);});
})();
